export default __webpack_public_path__ + "static/couples-mobile-052d8881f8fa1f6c1ca7513e70337dd6.svg";